/* Shared card carousel (homepage Ground Truth chrome).
   Root: [data-mm-carousel] with data-mm-visible.
   Track: .mm-cc__track inside .mm-cc__viewport.
   Optional: [data-mm-carousel-prev] [data-mm-carousel-next].
*/
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-mm-cc-ready') === '1') return;
    var track = root.querySelector('.mm-cc__track');
    var prevBtn = root.querySelector('[data-mm-carousel-prev]');
    var nextBtn = root.querySelector('[data-mm-carousel-next]');
    if (!track) return;
    root.setAttribute('data-mm-cc-ready', '1');

    var desktopVisible = Math.max(1, parseInt(root.getAttribute('data-mm-visible') || '3', 10));
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = [].slice.call(track.children);
    var index = 0;

    function visibleCount() {
      if (window.matchMedia('(max-width: 639px)').matches) return 1;
      if (window.matchMedia('(max-width: 989px)').matches) return Math.min(2, desktopVisible);
      return Math.min(desktopVisible, items.length || 1);
    }

    function maxIndex() {
      return Math.max(0, items.length - visibleCount());
    }

    function gapPx() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0');
      return isNaN(gap) ? 0 : gap;
    }

    function viewportEl() {
      return track.parentElement;
    }

    function itemWidthPx() {
      var vis = visibleCount();
      var gap = gapPx();
      var vp = viewportEl();
      var w = vp ? vp.clientWidth : 0;
      if (w <= 0 || vis < 1) return 0;
      return (w - gap * (vis - 1)) / vis;
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
    }

    function goTo(i, animate) {
      index = Math.max(0, Math.min(i, maxIndex()));
      if (reduceMotion || animate === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }
      var width = itemWidthPx();
      var offset = index * (width + gapPx());
      if (!(width > 0) && items[index]) {
        offset = items[index].offsetLeft;
      }
      track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      updateNav();
    }

    function layout() {
      var vis = visibleCount();
      var width = itemWidthPx();
      items.forEach(function (item) {
        if (width > 0) {
          item.style.flex = '0 0 ' + width + 'px';
          item.style.width = width + 'px';
          item.style.maxWidth = width + 'px';
        } else {
          item.style.flex = '0 0 calc((100% - ' + (gapPx() * (vis - 1)) + 'px) / ' + vis + ')';
          item.style.width = '';
          item.style.maxWidth = '';
        }
      });
      if (index > maxIndex()) index = maxIndex();
      goTo(index, false);
      updateNav();
    }

    function next() {
      goTo(index + 1, !reduceMotion);
    }

    function prev() {
      goTo(index - 1, !reduceMotion);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    var viewport = viewportEl();
    if (!viewport) return;

    var drag = {
      active: false,
      startX: 0,
      base: 0,
      moved: false,
      suppressClick: false
    };

    function currentOffset() {
      var width = itemWidthPx();
      var off = index * (width + gapPx());
      if (!(width > 0) && items[index]) off = items[index].offsetLeft;
      return off;
    }

    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag.active = true;
      drag.moved = false;
      drag.suppressClick = false;
      drag.startX = e.clientX;
      drag.base = currentOffset();
      track.style.transition = 'none';
      viewport.style.cursor = 'grabbing';
      try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
    }

    function onPointerMove(e) {
      if (!drag.active) return;
      var dx = e.clientX - drag.startX;
      if (Math.abs(dx) > 6) drag.moved = true;
      var width = itemWidthPx();
      var raw = drag.base - dx;
      var maxOff = maxIndex() * (width + gapPx());
      if (width > 0) {
        if (raw < 0) raw = raw * 0.35;
        else if (raw > maxOff) raw = maxOff + (raw - maxOff) * 0.35;
      }
      track.style.transform = 'translate3d(' + (-raw) + 'px, 0, 0)';
    }

    function onPointerUp(e) {
      if (!drag.active) return;
      drag.active = false;
      viewport.style.cursor = 'grab';
      var dx = e.clientX - drag.startX;
      var width = itemWidthPx();
      track.style.transition = '';
      if (drag.moved && width > 0) {
        var delta = Math.round(-dx / (width + gapPx()));
        if (delta === 0 && Math.abs(dx) > 40) delta = dx < 0 ? 1 : -1;
        if (delta !== 0) {
          drag.suppressClick = true;
          goTo(index + delta, !reduceMotion);
        } else {
          goTo(index, !reduceMotion);
        }
        if (drag.moved) drag.suppressClick = true;
      } else {
        goTo(index, !reduceMotion);
        if (drag.moved) drag.suppressClick = true;
      }
    }

    viewport.style.cursor = 'grab';
    viewport.style.touchAction = 'pan-y';
    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('click', function (e) {
      if (!drag.suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
      drag.suppressClick = false;
    }, true);

    var wheelAcc = 0;
    var wheelLock = false;
    viewport.addEventListener('wheel', function (e) {
      var dx = e.deltaX;
      var dy = e.deltaY;
      var dominant = Math.abs(dx) >= Math.abs(dy) ? dx : (e.shiftKey ? dy : 0);
      if (!dominant || Math.abs(dominant) < 1) return;
      e.preventDefault();
      wheelAcc += dominant;
      if (wheelLock || Math.abs(wheelAcc) < 36) return;
      wheelLock = true;
      if (wheelAcc > 0) next();
      else prev();
      wheelAcc = 0;
      window.setTimeout(function () { wheelLock = false; }, 280);
    }, { passive: false });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (drag.active) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 120);
    });
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        if (drag.active) return;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(layout, 60);
      });
      ro.observe(viewport);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(layout);
    });
  }

  function boot() {
    document.querySelectorAll('[data-mm-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
